import { AUTOMATION_PLATFORM_FLOW_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { registerQuery } from 'data-fetching-client';
import get from 'hs-lodash/get';
import without from 'hs-lodash/without';
import http from 'hub-http/clients/apiClient';
export const getWorkflow = data => get(data, 'actionFeatures_workflow');
export const GET_WORKFLOW = registerQuery({
  fieldName: 'actionFeatures_workflow',
  args: ['flowId'],
  fetcher: ({
    flowId
  }) => http.get(`automationapps/v1/flow-crm-objects/${flowId}`)
});
export const getWorkflowsResults = data => get(data, 'actionFeatures_workflows');
const args = ['count', 'objectTypeId', 'offset', 'query'];
export const GET_WORKFLOWS = registerQuery({
  fieldName: 'actionFeatures_workflows',
  args,
  fetcher: ({
    count,
    objectTypeId,
    offset,
    query
  }) => http.post('crm-search/search', {
    data: {
      count,
      filterGroups: [{
        filters: [{
          operator: 'EQ',
          property: 'hs_is_deleted',
          value: false
        }, {
          operator: 'EQ',
          property: 'hs_is_external',
          value: false
        }, {
          operator: 'EQ',
          property: 'hs_object_type_id',
          value: objectTypeId
        }]
      }],
      objectTypeId: AUTOMATION_PLATFORM_FLOW_TYPE_ID,
      offset,
      query,
      requestOptions: {
        properties: ['hs_enabled', 'hs_flow_id', 'hs_name']
      },
      sorts: [{
        property: 'hs_enabled',
        order: 'DESC'
      }, {
        property: 'hs_name',
        order: 'ASC'
      }]
    }
  })
});
export const workflowsQueryFieldPolicy = {
  actionFeatures_workflows: {
    keyArgs: without(args, 'offset'),
    merge(existing, incoming) {
      if (!existing) return incoming;
      return Object.assign({}, incoming, {
        results: [...existing.results, ...incoming.results]
      });
    }
  }
};